import { Link } from "react-router-dom";
import type { ReactNode } from "react";

const BRAND_GRADIENT = "linear-gradient(98deg,#8B5CF6 0%,#B16CEA 46%,#FF7A18 100%)";

export function PaymentShell({
  icon,
  eyebrow,
  title,
  children,
  footer,
}: {
  icon: ReactNode;
  eyebrow: string;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-[480px]">
        <div className="mb-6 text-center">
          <div
            className="mb-4 inline-flex items-center gap-2.5 text-[11.5px] font-semibold uppercase tracking-[0.18em] text-og01-violet"
          >
            <span className="h-[1.5px] w-6" style={{ background: BRAND_GRADIENT }} />
            {eyebrow}
          </div>
          <h1 className="font-heading text-[clamp(28px,4vw,36px)] font-normal leading-[1.1] text-og01-text">
            {title}
          </h1>
        </div>

        <section className="rounded-2xl border border-white/[0.07] bg-og01-card p-7">
          <div className="mb-5 grid h-[52px] w-[52px] place-items-center rounded-[14px] border border-white/[0.07] bg-[#0F0F18]">
            {icon}
          </div>
          {children}
        </section>

        {footer ? <div className="mt-5 text-center">{footer}</div> : null}

        <p className="mt-8 text-center text-[12px] text-og01-text-muted">
          <Link to="/auth/login" className="underline-offset-2 hover:text-og01-text hover:underline">
            Sign in
          </Link>
          {" · "}
          <span>OG01</span>
        </p>
      </div>
    </div>
  );
}

export { BRAND_GRADIENT };
